import { createBrowserRouter } from "react-router-dom";
import { DeveloperPage } from "react-better-html";

import Root from "./pages/Root";
import ErrorPage from "./pages/ErrorPage";
import Redirect from "./components/structure/Redirect";
import Restricted from "./components/structure/Restricted";

import AuthRoot from "./pages/auth/AuthRoot";
import Auth from "./pages/auth";
import DeleteUser from "./pages/auth/DeleteUser";

import OrganizationRoot from "./pages/organization/OrganizationRoot";
import CreateOrganization from "./pages/organization/CreateOrganization";

import LegalRoot from "./pages/legal/LegalRoot";
import TermsAndConditions from "./pages/legal/TermsAndConditions";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import DataProcessingAgreement from "./pages/legal/DataProcessingAgreement";

import AppRoot from "./pages/app/AppRoot";

import Dashboard from "./pages/app/Dashboard";

import Properties from "./pages/app/properties";
import AddProperty from "./pages/app/addProperty";
import SingleProperty from "./pages/app/properties/SingleProperty";

import Workspaces from "./pages/app/workspaces";
import SingleWorkspace from "./pages/app/workspaces/SingleWorkspace";

import Account from "./pages/app/account";

import Notifications from "./pages/app/Notifications";

import Settings from "./pages/app/settings";

import Support from "./pages/app/Support";

export const router = createBrowserRouter([
   {
      path: "/",
      element: <Root />,
      errorElement: <ErrorPage />,
      children: [
         {
            path: "auth",
            element: <AuthRoot />,
            children: [
               {
                  index: true,
                  element: <Auth />,
               },
               {
                  path: "delete-user",
                  element: <DeleteUser />,
               },
            ],
         },
         {
            path: "organization",
            element: <OrganizationRoot />,
            children: [
               {
                  index: true,
                  element: <Redirect to="/" />,
               },
               {
                  path: "create",
                  element: <CreateOrganization />,
               },
            ],
         },
         {
            path: "legal",
            element: <LegalRoot />,
            children: [
               {
                  index: true,
                  element: <Redirect to="/" />,
               },
               {
                  path: "terms-and-conditions",
                  element: <TermsAndConditions />,
               },
               {
                  path: "privacy-policy",
                  element: <PrivacyPolicy />,
               },
               {
                  path: "data-processing-agreement",
                  element: <DataProcessingAgreement />,
               },
            ],
         },
         {
            path: "/",
            element: <AppRoot />,
            children: [
               {
                  index: true,
                  element: <Redirect to="/dashboard" />,
               },
               {
                  path: "dashboard",
                  element: <Dashboard />,
               },
               {
                  path: "properties",
                  children: [
                     {
                        index: true,
                        element: <Properties />,
                     },
                     {
                        path: "add",
                        element: <AddProperty />,
                     },
                     {
                        path: ":propertyId",
                        element: <SingleProperty />,
                     },
                  ],
               },
               {
                  path: "workspaces",
                  children: [
                     {
                        index: true,
                        element: (
                           <Restricted organizationTypes={["AGENCY"]}>
                              <Workspaces />
                           </Restricted>
                        ),
                     },
                     {
                        path: ":workspaceId",
                        children: [
                           {
                              index: true,
                              element: <SingleWorkspace />,
                           },
                           {
                              path: "properties",
                              children: [
                                 {
                                    index: true,
                                    element: <Redirect to="/workspaces/:workspaceId" />,
                                 },
                                 {
                                    path: ":propertyId",
                                    element: <SingleProperty />,
                                 },
                              ],
                           },
                        ],
                     },
                  ],
               },
               {
                  path: "notifications",
                  element: <Notifications />,
               },
               {
                  path: "account",
                  element: <Account />,
               },
               {
                  path: "settings",
                  element: <Settings />,
               },
               {
                  path: "support",
                  element: <Support />,
               },
               {
                  path: "dev",
                  element: <DeveloperPage />,
               },
            ],
         },
      ],
   },
]);
